// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"266c58ce","105":"0e5b60c9","731":"dd74d201","858":"8deefd84"}[chunkId] + ".chunk.js";
};